<template>
  <fieldset class="birthdate-group" ref="birthdateFieldset" :class="[
    !disabled ? vflowGetFeedbackClasses('birthdate') : '',
    {'mandatory': mandatory},
    width !== '' ? 'width' + width : ''
  ]">
    <label
      @mousedown="isLabelClicked = true"
      @blur="isLabelClicked = false"
      :for="name">
      <slot name="lblBirthdate">Geburtsdatum</slot>
    </label>
    <b-form-input
      :id="name"
      :key="'birthDateInputField' + refreshKeyBirthDate"
      :value="getBirthdate()"
      @mousedown="isClicked = true"
      @blur="vflowInputBlurred('birthdate'); blurredBirthdate(); isClicked = false; isFocusedWithoutClick = false"
      @click="clickedBirthdate"
      @focus="vflowInputFocused('birthdate'); onFocus()"
      @input.native="handleInputBirthdate"
      @keydown="keypressBirthdate"
      :aria-describedby="hasErrorClasses && $v.birthdate.$invalid ? 'errmsg-' +name : ''"
      :aria-invalid="$v.birthdate.$invalid"
      autocomplete="off"
      :class="['date-type-assisted', isFocusedWithoutClick ? 'is-focus-visible' : '']"
      :name="name"
      placeholder="TT.MM.JJJJ"
      ref="birthDateInputField"
      required
      type="text"
      :disabled="disabled"
    ></b-form-input>
    <b-form-invalid-feedback  :id="'errmsg-' +name" role="alert">
      <slot name="txtInvalidRequiredBirthDateLiveFeedback" v-if="!$v.birthdate.required">Dies ist ein Pflichtfeld.</slot>
      <slot name="txtInvalidBirthDateLiveFeedback" v-else-if="!$v.birthdate.hasValidDateFormat || !$v.birthdate.isPassedDate">Dies ist kein gültiges Datum.</slot>
      <slot name="txtTooYoungBirthDateLiveFeedback" v-if="$v.birthdate.hasValidDateFormat && $v.birthdate.isPassedDate && !$v.birthdate.hasMinAge">Für dich gilt der Welpenschutz - du bist leider zu jung.</slot>
    </b-form-invalid-feedback>
  </fieldset>
</template>

<script>
import isValid from '../../mixins/validators/isValid'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import validationFlow from '@/mixins/validators/validationFlow'
import date from '@/mixins/validators/date'
import syncProperty from '@/mixins/syncProperty'

export default {
  name: 'LabeledBirthdateInput',
  props: {
    name: {
      type: String,
      default: 'birthDate'
    },
    checkForMinAge: {
      type: Number,
      default: 0
    },
    width: {
      type: String,
      default: '',
      validator: function (value) {
        return ['25', '33', '66', '75', ''].includes(value)
      }
    },
    mandatory: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      refreshKeyBirthDate: 0,
      updateBirthDate: false,
      isFocusedWithoutClick: false,
      isClicked: false,
      isLabelClicked: false,
      hasErrorClasses: false
    }
  },
  mounted () {
    this.formatBirthdate(this.birthdate)
    this.$v.$reset()
    this.hasErrorClasses = (!!this.vflowGetFeedbackClasses('birthdate')['required-failed'] || !!this.vflowGetFeedbackClasses('birthdate')['other-validation-failed']) && !!this.vflowGetFeedbackClasses('birthdate')['show-feedback']
    this.observeClassChange()
  },
  components: { },
  watch: {
    '$v.$invalid': {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:invalid', newValue)
      }
    }
  },
  mixins: [
    validationMixin,
    isValid,
    date,
    validationFlow,
    syncProperty('date', 'birthdate'),
    syncProperty('invalid', 'invalid_')
  ],
  methods: {
    setCursorPosition (el, pos) {
      el.focus()
      el.setSelectionRange(pos, pos)
    },
    isFormatableDate (v) {
      // replace all invalid characters
      const dv = (v && v !== null) ? v.replace(/([^0-9.])/g, '').trim() : ''

      // split into date parts
      const m = dv.match(/^(3[01]|[12][0-9]|0?[1-9])(\.*)(1[0-2]|0?[1-9])?(\.*)(\d{1,4})?$/)
      if (m !== null) {
        return true
      }

      return false
    },
    formatDateExpression (v, event) {
      // replace all invalid characters
      const dv = (v && v !== null) ? v.replace(/([^0-9.])/g, '').trim() : ''

      // split into date parts
      const m = dv.match(/^(3[01]|[12][0-9]|0?[1-9])(\.*)(1[0-2]|0?[1-9])?(\.*)(\d{1,4})?$/)
      if (m !== null) {
        const inpDay = (typeof m[1] !== 'undefined' ? m[1] : null)
        const dotDay = (typeof m[2] !== 'undefined' ? (m[2] === '.') : false)
        const inpMonth = (typeof m[3] !== 'undefined' ? m[3] : null)
        const dotMonth = (typeof m[4] !== 'undefined' ? (m[4] === '.') : false)
        const inpYear = (typeof m[5] !== 'undefined' ? m[5] : null)

        const day = parseInt(inpDay)
        const month = parseInt(inpMonth)

        const dayComplete = inpDay !== null && (inpDay.length === 2 || dotDay || parseInt(inpDay.substr(0, 1)) > 3)
        const monthComplete = inpMonth !== null && (dayComplete && (inpMonth.length === 2 || dotMonth || parseInt(inpMonth.substr(0, 1)) > 1))

        let de = ''
        if (dayComplete) {
          de = (day < 10 ? '0' + day.toString() : day) + '.'
        } else {
          de = (inpDay !== null ? inpDay : '')
        }

        if (monthComplete) {
          de = de + (month < 10 ? '0' + month.toString() : month) + '.'
        } else {
          de = de + (inpMonth !== null ? inpMonth : '')
        }

        de = de + (inpYear !== null ? inpYear : '')

        return de
      }

      return v
    },
    filterDateInput (e) {
      const keyCode = e.which || e.code
      let key = e.key
      const validKeyCodes = [
        13, // Enter
        37, // ArrowLeft
        39, // ArrowRight
        8, // Backspace
        46, // Delete
        36, // Home
        35, // End
        9 // Tab
      ]

      // if we are on android
      if (key === 'Unidentified') {
        return false
      }

      if (!key) {
        key = String.fromCharCode(keyCode)
      }

      if (!/[0-9.]/.test(key) && validKeyCodes.indexOf(keyCode) === -1) {
        e.preventDefault()
        e.stopPropagation()
      } else if (keyCode === 13) {
        this.$v.$touch()
      }
    },
    handleBirthdateKeypress (v, e, startPos) {
      this.filterDateInput(e)
      if (e.key === '.') {
        const afterDotResult = v.substring(0, startPos) + '.' + v.substring(startPos)
        const numDots = (v.match(/\./g) || []).length
        let prevent = (afterDotResult.indexOf('..') !== -1 || numDots > 2)

        // check if user will be between dots
        if (prevent && numDots === 1) {
          if (v.substring(startPos + 1, startPos) === '.') {
            prevent = false
          }
        }

        if (prevent) {
          e.preventDefault()
          e.stopPropagation()
          return false
        }
      }
    },
    keypressBirthdate (e) {
      this.handleBirthdateKeypress(this.birthdate, e, this.$refs.birthDateInputField.selectionStart)
      const triggerKeys = ['Home', 'End', 'Tab']
      if (triggerKeys.indexOf(e.key) !== -1) {
        this.updateBirthDate = true
        this.formatBirthdate(this.birthdate)
      }
    },
    handleInputBirthdate (e) {
      if (/[^0-9.]+/.test(e.target.value)) {
        const v = e.target.value.replace(/([^0-9.])/g, '').trim()
        setTimeout(() => {
          this.birthdate = v
          this.formatBirthdate(this.birthdate)
          this.blurredBirthdate()
          this.$nextTick(() => {
            this.$refs.birthDateInputField.$el.focus()
          })
        }, 250)
      } else {
        this.formatBirthdate(e.target.value)
      }

      this.$v.$touch()
    },
    clickedBirthdate (e) {
      const startPos = this.$refs.birthDateInputField.selectionStart
      if (startPos >= this.birthdate?.length) {
        this.formatBirthdate(this.birthdate)
      }
    },
    blurredBirthdate () {
      this.refreshKeyBirthDate += 1
      this.formatBirthdate(this.birthdate)
    },
    formatBirthdate (v) {
      const force = this.vflowIsBlurred('birthdate')
      const startPos = this.$refs.birthDateInputField.selectionStart
      const update = (this.isFormatableDate(v) && (this.updateBirthDate || force || startPos >= v.length))
      if (update) {
        this.$nextTick(() => {
          this.updateBirthDate = false
          this.birthdate = this.formatDateExpression(v)
          this.$v.birthdate.$touch()
        })
      } else {
        this.birthdate = v
        this.$v.birthdate.$touch()
      }
    },
    getBirthdate () {
      return this.birthdate
    },
    selectDate (ctx) {
      if (ctx.selectedDate) {
        this.birthdate = ctx.selectedFormatted
      }
    },
    onFocus () {
      if (!this.isClicked && !this.isLabelClicked) {
        this.isFocusedWithoutClick = true
      }

      this.isLabelClicked = false
    },
    observeClassChange () {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            this.hasErrorClasses = (!!this.vflowGetFeedbackClasses('birthdate')['required-failed'] || !!this.vflowGetFeedbackClasses('birthdate')['other-validation-failed']) && !!this.vflowGetFeedbackClasses('birthdate')['show-feedback']
          }
        })
      })

      observer.observe(this.$refs.birthdateFieldset, { attributes: true, attributeFilter: ['class'] })
    }
  },
  validations () {
    return {
      birthdate: {
        required,
        hasValidDateFormat (v) {
          return this.validDateFormatOnlyForNonEmpty(this.formatDateExpression(v))
        },
        hasValidDate (v) {
          return this.validDate(this.formatDateExpression(v))
        },
        isPassedDate (v) {
          if (typeof v !== 'undefined' && v !== '' && this.validDateFormatOnlyForNonEmpty(this.formatDateExpression(v)) && v !== null) {
            return this.validGivenAge(v, 0)
          }
          return true
        },
        hasMinAge (v) {
          if (this.checkForMinAge > 0 && typeof v !== 'undefined' && v !== '' && this.validDateFormatOnlyForNonEmpty(this.formatDateExpression(v)) && v !== null) {
            return this.validGivenAge(v, this.checkForMinAge)
          }

          return true
        }
      }
    }
  }
}
</script>
